import * as Yup from "yup";

// Login Validation
export const userDurationSchema = (number) =>
	Yup.object().shape({
		durations: Yup.number().required().min(30).label("Durations"),
	});
